<template>
  <div>
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd(true)"
          
        >新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="danger"
          plain
          icon="el-icon-delete"
          size="mini"
          @click="handleDeleteAll">删除</el-button>
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="userList"  @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="名称" prop="Name" />
      <el-table-column label="提供商" prop="CompanyName" :show-overflow-tooltip="true"  />
      <el-table-column label="api地址" prop="Url" :show-overflow-tooltip="true"  />
      <el-table-column label="ApiKey" prop="ApiKey" :show-overflow-tooltip="true"  />
      <el-table-column label="操作" width="280"  align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope" >
          <el-button
            size="mini"
            type="text"
            icon="el-icon-tickets"
            @click="handleDetail(scope.row)"
           
          >详情</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
           
          >编辑</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-show="total>0"
      :total="total"
      :page-sizes="[2, 5, 10, 15]"
      layout="total, sizes, prev, pager, next, jumper"
      :page.sync="queryParams.pageIndex"
      :limit.sync="queryParams.pageSize"
      @pagination="handleQuery"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage1"
    />
    <!-- 详情 -->
    <el-dialog title="详情"  class="openDialog" :visible.sync="detailOpen" width="650px" append-to-body>
        <el-form  label-width="100px">
          <el-col :span="12">
          <el-form-item label="名称:" >
            {{form.Name}}
          </el-form-item>
        </el-col>
          <el-col :span="12">
          <el-form-item label="提供商:">
            {{form.CompanyName}}
          </el-form-item>
        </el-col>
          <el-col :span="12">
          <el-form-item label="api地址:" >
            {{form.Url}}
          </el-form-item>
        </el-col>
          <el-col :span="12">
          <el-form-item label="ApiKey:">
            {{form.ApiKey}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="模型标识:" >
            {{form.ModelTag}}
          </el-form-item>
        </el-col>
          <el-col :span="12">
          <el-form-item label="SecrerKey:">
            {{form.SecrerKey}}
          </el-form-item>
        </el-col>
          <el-col :span="12">
          <el-form-item label="备注:" >
            {{form.Remark}}
          </el-form-item>
        </el-col>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelDetail">取 消</el-button>
        </div>
      </el-dialog>
     <!-- 添加或修改角色配置对话框 -->
     <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body class="search2">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-col :span="12">
        <el-form-item label="名称" prop="Name">
          <el-input v-model="form.Name" placeholder="请输入名称" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item  label="提供商" prop="CompanyType">
          <el-select v-model="form.CompanyType" @change="getCompanyTypeName"
                   placeholder="请选择提供商">
          <el-option v-for="item in companyOptions"
                     :key="item.Value"
                     :label="item.Name"
                     :value="item.Value">
          </el-option>
        </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item  label="api地址" prop="Url">
          <el-input v-model="form.Url" placeholder="请输入api地址" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="ApiKey" prop="ApiKey">
          <el-input v-model="form.ApiKey" placeholder="请输入ApiKey" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item  label="模型标识" prop="ModelTag">
          <el-input v-model="form.ModelTag" placeholder="请输入模型标识" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item  label="SecrerKey" prop="SecrerKey">
          <el-input v-model="form.SecrerKey" placeholder="请输入SecrerKey" />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="备注" prop="Remark">
          <el-input type="textarea" v-model="form.Remark" placeholder="请输入备注" />
        </el-form-item>
      </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { companyTypeAIModelConfig,addAIModelConfig,listAIModelConfig,editAIModelConfig,deleteAIModelConfig,detailAIModelConfig } from "@/api/aimodel.js";
export default {
  name:'aiModelConfig',
  data(){
    return{
      currentPage1:1,
      queryParams:{
        pageIndex: 1,
        pageSize: 10,
        roleName: undefined,
      },
      loading:false,
      userList:[],
      total:0,
      open:false,
      detailOpen:false,
      title:'设置角色',
      configform:{
        Name:'',
        CompanyType:'',
        Url:'',
        ApiKey:'',
        ModelTag:'',
        SecrerKey:'',
        Remark:'',
      },
      form:{},
      rules: {
        Name: [
          { required: true, message: "名称不能为空", trigger: "blur" }
        ],
        CompanyType: [
          { required: true, message: "提供商不能为空", trigger: "change" }
        ],
        Url: [
          { required: true, message: "api地址不能为空", trigger: "blur" }
        ],
        ApiKey: [
          { required: true, message: "ApiKey不能为空", trigger: "blur" }
        ]
      },
      multipleSelection:[],
      companyOptions: [],
    }
  },
  mounted(){
    this.form={...this.configform}
    this.getCompanyTypeOptions()
    this.handleQuery()
},
  methods:{
    async getCompanyTypeOptions(){
      const [res,err]=await companyTypeAIModelConfig()
      this.companyOptions=res.data.Data.map(item=>{
        return{
          Name:item.Name,
          Value:Number(item.Value)
        }
      })
    },
    async handleQuery(){
      const [res,err] = await listAIModelConfig(this.queryParams);
      if (res.data.Code==1) {
        this.userList = res.data.Data;
        this.total = res.data.TotalCount;
      }
    },
    handleAdd(){
      this.title='新增'
      this.open=true
      this.form={...this.configform}
    },
    // 批量删除1
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => item.Id);
    },
    // 批量删除1
    handleDeleteAll () {
      var obj = this.multipleSelection
      if(obj.length==0){
        this.$message.error('请选择数据')
        return
      }
      this.$confirm('此操作将永久删除选中的用户信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
          var obj = this.multipleSelection
          // 批量删除1
          const [res, err] = await deleteAIModelConfig(obj)
        
          this.handleQuery()

      })
    },
    async handleDetail(row){
      this.detailOpen=true
      const [res,err]=await detailAIModelConfig(row.Id)
      let rowData=res.data.Data
      this.form=rowData
    },
    async handleUpdate(row){
      
      this.title='编辑'
      this.open=true
      this.$set(this,'form',{...row})
    },
    handleDelete(row){
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const [res,err]=await deleteAIModelConfig(row.Id)
        
          this.handleQuery()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    getCompanyTypeName(e){
      this.form.CompanyName=this.companyOptions.filter(item=>item.Value==e)[0].Name
    },
    
    handleSizeChange(val) {
      this.queryParams.pageSize=val
      this.handleQuery()
    },
    handleCurrentChange(val) {
      this.queryParams.pageIndex=val
      this.handleQuery()
    },
    submitForm(){
      this.$refs.form.validate(async (valid)=>{
        if (valid) {
          if(this.form.Id){
            const [res,err]=await editAIModelConfig(this.form)
          }else{
            const [res,err]=await addAIModelConfig(this.form)
          }
          this.handleQuery()
          this.cancel()
        }
      })
    },
    cancel(){
      this.$refs.form?.resetFields()
      this.open=false
    },
    
    cancelDetail(){
      this.detailOpen=false
    },
  }
}
</script>

<style scoped>
.search2 ::v-deep(.el-dialog__body){
  display: table;
}
.openDialog ::v-deep(.el-dialog__body){
  display: table;
}
</style>